import { put, all } from "redux-saga/effects";
import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "../messages";

function* updateLeadUtilityBill(action) {
  const { leadId, utility_bill_url, uuid, anon } = action.payload;

  if (!leadId && !uuid) {
    throw new Error(`Invalid lead ID = ${leadId || uuid} specified. Please check this parameter.`);
  }
  const params = {
    utility_bill_url,
  };

  const endpoint = anon ? `/anon_leads/${uuid}/bill` : `/leads/${leadId}/bill`;
  const { success, data, error } = yield* makeRequest.patch(endpoint, params);
  if (success && data) {
    yield all([put(actions.newSuccessEvent({ message: messages.LEAD_UPDATE_SUCCESS }))]);
  } else {
    return getErrorActions({ error, message: messages.ERROR_UPDATING_LEAD });
  }
  return null;
}

export default updateLeadUtilityBill;
